import Vue from 'vue'

const triggerResize = () => {
  Vue.nextTick(() => {
    if (window.dispatchEvent && window.Event) {
      window.dispatchEvent(new Event('resize'))
    } else if (window.document.createEvent) {
      const resizeEvent = window.document.createEvent('UIEvents')
      resizeEvent.initUIEvent('resize', true, false, window, 0)
      window.dispatchEvent(resizeEvent)
    }
  })
}

export default triggerResize



// WEBPACK FOOTER //
// ./src/util/triggerResize.js